import { Controller } from '@hotwired/stimulus'
import Chartkick from 'chartkick'

export default class extends Controller {
  static targets = ['select', 'chart']
  static values = {
    chartData: Object
  }

  connect() {
    // Initialize the chart with the default selected year
    this.updateChart()
  }

  updateChart() {
    const selectedYear = this.selectTarget.value
    const chartData = this.chartDataValue[selectedYear] || {}

    // Clear existing chart
    this.chartTarget.innerHTML = ''

    // Create new chart with the selected year's data
    new Chartkick.ColumnChart(
      this.chartTarget,
      chartData,
      {
        prefix: 'R',
        thousands: ',',
        colors: ['rgba(55,117,217, 1)'] // #3775D9
      }
    )
  }

  yearChanged() {
    this.updateChart()
  }
}
